
if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"c-info clearfix\">\n    <a class=\"c-info__icon fl\" href=\"//zhibo.ifeng.com/?columnId=")
    ; __append(escape(columnId))
    ; __append("\">\n        <img src=\"")
    ; __append(escape(channelIcon))
    ; __append("\" alt=\"\">\n    </a>\n    <a class=\"c-info__title fl\" href=\"//zhibo.ifeng.com/?columnId=")
    ; __append(escape(columnId))
    ; __append("\">")
    ; __append(escape(channelName))
    ; __append("</a>\n</div>\n<div class=\"c-title clearfix\">\n    <h1 class=\"fl\">\n        ")
    ; __append(escape(title))
    ; __append("\n    </h1>\n    <div class=\"statebox fl\">\n        <span class=\"state \">\n        ")
    ; __append(escape(state))
    ; __append("\n    </span>\n    </div>\n    <div class=\"onlinebox fl\">\n        <span class=\"online\">\n        0</span>\n    </div>\n    <div class=\"c-share-root fr\">\n    </div>\n</div>\n<div class=\"content-box clearfix\">\n    <div class=\"c-left fl\">\n        <div class=\"c-core-root\">\n        </div>\n    </div>\n    <div class=\"c-right fr\">\n        <div class=\"c-chart-root fr\">\n        </div>\n    </div>\n</div>\n")
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/modules/header/main.ejs
// module id = 366
// module chunks = 0